import { createValidation } from '../../utils/validation';

export const createReturnedProductInspectionValidationSchema = (fields) => {
  const validation = createValidation(fields);

  return {
    schema: validation.schema,
    validateData: validation.validateData,
    validateReturnedProductInspectionData: validation.validateData,
    validateField: validation.validateField,
  };
};

export default createReturnedProductInspectionValidationSchema;
